module.exports = __webpack_public_path__ + "static/mfs-bf7872f6a20667855b8ba88506418ac9.png";